import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 84402452-AA4A-43D6-A26C-A0946B48310C
 * name minecraft
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minecraft.svg
 * tags
 * - Brand / Logo 
 */
export const MinecraftIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M6,6V10H10V12H8V18H10V16H14V18H16V12H14V10H18V6H14V10H10V6H6Z" /></>, 'MinecraftIcon');
export default MinecraftIcon